import { Link } from '@framework/router/Next/Link';
import { LogoFinsightCompact } from '@dealroadshow/uikit-logo/Finsight/Compact';
import { LogoFinsightText } from '@dealroadshow/uikit-logo/Finsight/Text';
import { ColorType } from '@creditflowresearch/uilib/Logo/types';
import styles from './logo.module.scss';

interface ILogoProps {
  onClick: () => void,
}
const Logo = ({ onClick }: ILogoProps) => (
  <Link
    to="/"
    dataTest="finsightLogoLink"
    className={ styles.logo }
    onClick={ onClick }
  >
    <LogoFinsightCompact
      colorType={ ColorType.WHITE }
      className={ styles.logoWings }
    />
    <LogoFinsightText
      colorType={ ColorType.WHITE }
      className={ styles.logoCompanyName }
    />
  </Link>
);

export default Logo;
